import React from 'react';

export const homeContent = {
  TITLE: 'WALDO for Doctors',
  CTA: 'GET IN TOUCH',
  WHY_PARTNER_US: {
    TITLE: 'Why partner with us?',
    CONTENT: {
      TITLE_1: 'No more missed revenue',
      TITLE_2: 'Rewards for you, regardless',
      TITLE_3: 'Straightforward processes',
      TITLE_4: 'Transparent & low pricing',
      DESC_1: (
        <>
          <span className="underline font-normal">5 out of 10 patients</span>
          &nbsp; walk out of their eye exam without purchasing from your office.
          WALDO will help you capture that revenue and keep patients buying from
          you.
        </>
      ),

      DESC_1_mobile: (
        <>
          <span className="underline font-normal">5 out of 10 patients</span>
          &nbsp; walk out of their eye exam without purchasing from your office.
        </>
      ),

      DESC_1_mobile_1: (
        <>
          WALDO will help you capture that revenue and keep patients buying from
          you.
        </>
      ),

      DESC_2: (
        <>
          You’ll reap the benefits wherever and whenever your patients decide to
          buy.
        </>
      ),
      DESC_2_2: (
        <span className="font-normal text-base">
          You&apos;ll be rewarded for every sale as long as the patient is
          wearing WALDO lenses.
        </span>
      ),
      DESC_3:
        'WALDO Doctor Partners earn 35% of every order, whether patients order in-office or online, and continue earning as patients renew.',
      DESC_4: (
        <>
          We describe our pricing with one word:&nbsp;
          <span className="font-normal">simple.</span>
        </>
      ),
      DESC_4_2:
        'We believe everyone should be able to afford to wear premium quality lenses, so we’ve priced ours far lower than other big brand equivalents of the same quality.',
      DESC_4_3: (
        <span className="font-normal text-base">
          Patients pay one price, no matter where they purchase their
          subscription.
        </span>
      ),
    },
  },
  GET_IN_TOUCH: {
    CTA_HERO:
      "Let us show you how we can help you give your patients what they're looking for.",
  },
  CORPORATE_RES: {
    TITLE: 'Corporate responsibility',
    DESC: "Our recycling scheme, charitable partnerships and other corporate social initiatives mean WALDO patients know they're making a difference.",
  },
};

export const threeThings = [
  {
    title: 'Championing vision',
    class: 'mb-0 lg:mb-20',
    content:
      'We strive to make eyecare an integral part of self care and are dedicated to championing vision. We believe positive vision has no limits and are committed to delivering products and services that demonstrate this.',
  },
  {
    title: 'Quality first',
    class: 'mb-0 lg:mb-24',
    content:
      'Our products are medically endorsed by industry experts and made from the highest quality materials. We work with teams of internationally recognized doctors and manufacturers to provide the highest quality eyecare possible. ',
  },
  {
    title: 'Making human-centered decisions',
    class: 'mb-0 lg:mb-0',
    content:
      'We sell directly to our customers’ doors via straight-forward processes meaning we can tailor our service to fit into our patients’ lifestyles seamlessly, and pass on the savings. ',
  },
];
